import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const failures = ['Las rutinas rígidas fallan porque no perdonan un mal día en el trabajo o un imprevisto con los niños.', 'El orden por maratones es insostenible porque consume tu único tiempo de descanso real.', 'Separar la cocina de la limpieza duplica tu carga de trabajo innecesariamente.', 'Confiar en la "fuerza de voluntad" es un error cuando llegas a casa con el tanque de energía vacío.'];
  return <section className="py-20 bg-white" data-id="element-146">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-147">
        <FadeIn data-id="element-148">
          <h2 className="text-3xl md:text-4xl text-center text-charcoal mb-16" data-id="element-149">
            Por qué lo que has intentado no funciona
          </h2>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-150">
            {failures.map((text, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-151">
                <div className="flex items-start p-6 bg-linen rounded-xl h-full" data-id="element-152">
                  <XCircle className="text-terracotta shrink-0 mt-1 mr-4" size={24} strokeWidth={1.5} data-id="element-153" />
                  <p className="text-charcoal leading-relaxed" data-id="element-154">{text}</p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}